import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function HistoryPage() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/trade-history', { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: '#F7F8FC' }}>
      <div className="text-center">
        <div className="w-8 h-8 mx-auto border-2 border-indigo-500 border-t-transparent rounded-full animate-spin" />
        <p className="text-gray-400 text-xs mt-3">正在进入历史交易记录</p>
      </div>
    </div>
  );
}
